import api from "@/lib/api";
import { toast } from "sonner";

// Shows a one-tap "confirm status change" toast when the backend suggests advancing
// an order's status (e.g. after recording a purchase or a fully-paid payment).
export function maybeSuggestStatus(data, onApplied) {
  const s = data?.suggested_status;
  const oid = data?.order_id;
  if (!s || !oid) return;
  toast("Perbarui status order?", {
    description: `Ubah status order ini ke ${s}?`,
    duration: 8000,
    action: {
      label: `Set ${s}`,
      onClick: async () => {
        try {
          await api.post(`/orders/${oid}/status`, { status: s, note: "Auto dari aksi" });
          toast.success(`Status \u2192 ${s}`);
          onApplied && onApplied();
        } catch (e) {
          toast.error(e?.response?.data?.detail || "Gagal ubah status");
        }
      },
    },
  });
}
